import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledCollaborators = styled.div`
  margin: 20px 0;

  .collaborators-header-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  & .collaborators-content {
    margin-top: 30px;
    height: calc(100dvh - 338px);
  }

  & .search-container {
    width: 250px;
  }

  & .filters-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  & .filters-row {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
      flex-wrap: wrap;
    }
  }

  & > .collaborators-footer {
    position: sticky;
    bottom: 0;
    background-color: ${theme.colors.white};
    padding: 12px 20px;
    border-radius: 8px;
    margin: 20px 0 -20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > .buttons-container {
      display: flex;
      gap: 20px;
      justify-content: end;
    }
  }
`;
